import { SET_CDS_POINTS_PREVIEW } from 'constants/ActionTypes';

const setCdsPointsPreview = (token, amount) => ({
  type: SET_CDS_POINTS_PREVIEW,
  token,
  amount,
});

export default setCdsPointsPreview;
